import * as angular from "angular";
import {QuickFilterContextService} from "../commons/services/quick-filter-context.service";
import {OmsRequestsService} from "./services/oms-requests.service";
import {SettingsService} from "../site-preferences/services/settings-service.service";
import {DateRangeTimeFiltersService} from "../commons/services/date-range-time-filters.service";
import {ViewFilterSettingsService} from "../commons/services/view-filter-settings.service";
import {CommonsService} from "../commons/services/commons-service.service";
import {BatchRequestsService} from "../batch/services/batch-requests.service";

angular
  .module('bringoz.admin.oms')
  .config(OmsConfig);

/* @ngInject */
function OmsConfig($stateProvider, moment) {

  $stateProvider

    // Orders
    .state('orders', {
      parent: 'bringoz.site',
      url: '/orders',
      abstract: true,
      template: '<ui-view>'
    })

    // Orders
    .state('orders.table', {
      url: '/table?:status&:due&:from&:to&:queryString&:branchIds&:accountIds&:serviceAreaIds&:noArea&:tags&:attempts&:isPacked&:obligateTimeWindow&:schedulingRequired&:fulfillmentDisplayStatus' +
        '&:noFromLocation&:noToLocation&:pickupDepotIds&:destinationDepotIds&:configuredFieldName&:configuredFieldValue&:dateRangeTemplateType&:programTypes&:addressQualities&:schedulingSmsStatuses',
      controllerAs: 'vm',
      reloadOnSearch: false,
      template: '<oms-orders-view status="vm.status" due="vm.due" from="vm.from" to="vm.to" query-string="vm.queryString" ' +
        'branch-ids="vm.branchIds" account-ids="vm.accountIds" service-area-ids="vm.serviceAreaIds" no-area="vm.noArea" tags="vm.tags" ' +
        'attempts="vm.attempts" is-packed="vm.isPacked" configured-field-name="vm.configuredFieldName" configured-field-value="vm.configuredFieldValue" ' +
        'obligate-time-window="vm.obligateTimeWindow" scheduling-required="vm.schedulingRequired" fulfillment-display-status="vm.fulfillmentDisplayStatus"' +
        ' no-from-location="vm.noFromLocation" no-to-location="vm.noToLocation" pickup-depot-ids="vm.pickupDepotIds" destination-depot-ids="vm.destinationDepotIds" address-qualities="vm.addressQualities" ' +
        'selected-quick-filter-id="vm.selectedQuickFilterId" date-range-template-type="vm.dateRangeTemplateType" program-types="vm.programTypes" scheduling-sms-statuses="vm.schedulingSmsStatuses"></oms-orders-view>',
      controller: function (triBreadcrumbsService, commonsService: CommonsService, omsConstants, $stateParams, dateRangeTimeFiltersService: DateRangeTimeFiltersService,
                            splitService, metadataSettings, quickFilterContextService: QuickFilterContextService, $state,
                            viewFilterSettingsService: ViewFilterSettingsService, site) {

        const OmsSettings = splitService.getSiteOmsSettings(site.id);
        const quickActiveFilter = viewFilterSettingsService.getActiveQuickFilter($state.current.name);

        this.dateRangeTemplateType = $stateParams.dateRangeTemplateType || quickActiveFilter?.settings.dateRangeTemplateType;
        // if (this.dateRangeTemplateType) {
        //   const dateRangeFilter = dateRangeTimeFiltersService.getDateRangeFilterByType(this.dateRangeTemplateType);
        //   this.from = dateRangeFilter.dateStart;
        //   this.to = dateRangeFilter.dateEnd;
        // } else {
        //   this.from = $stateParams.from ? parseInt($stateParams.from) : undefined;
        //   this.to = $stateParams.to ? parseInt($stateParams.to) : undefined;
        // }

        if ($stateParams.from && $stateParams.to) {
          this.from = parseInt($stateParams.from)
          this.to = parseInt($stateParams.to);
        } else if (this.dateRangeTemplateType) {
          const dateRangeFilter = dateRangeTimeFiltersService.getDateRangeFilterByType(this.dateRangeTemplateType);
          this.from = dateRangeFilter.dateStart;
          this.to = dateRangeFilter.dateEnd;
        } else if (!!(OmsSettings.daysBefore || OmsSettings.daysAfter)) {
          this.from = moment().subtract(OmsSettings.daysBefore || 0, 'days').startOf('day').valueOf();
          this.to = moment().add(OmsSettings.daysAfter || 0, 'days').endOf('day').valueOf();
        }
        // else {
        //   this.from = _.get(contextRange, 'from');
        //   this.to = _.get(contextRange, 'to');
        // }

        this.siteId = splitService.getSiteId();
        this.selectedQuickFilterId = quickActiveFilter?.id;
        this.status = $stateParams.status || OmsSettings.defaultGroup;
        this.due = $stateParams.due ? parseInt($stateParams.due) : (quickActiveFilter?.settings?.dueTo || undefined);
        this.branchIds = commonsService.parseArrayStateParam($stateParams.branchIds) || quickActiveFilter?.settings?.branchIds || viewFilterSettingsService.getBranchIds() || [];
        this.accountIds = commonsService.parseArrayStateParam($stateParams.accountIds) || quickActiveFilter?.settings?.accountIds || viewFilterSettingsService.getAccountIds() || [];
        this.serviceAreaIds = commonsService.parseArrayStateParam($stateParams.serviceAreaIds) || quickActiveFilter?.settings?.serviceAreaIds || viewFilterSettingsService.getServiceAreaIds() || [];
        this.noArea = !!$stateParams.noArea ? JSON.parse($stateParams.noArea) : quickActiveFilter?.settings?.noArea;
        this.tags = $stateParams.tags || quickActiveFilter?.settings?.tags || [];
        this.queryString = $stateParams.queryString;
        this.attempts = $stateParams.attempts;
        this.isPacked = $stateParams.isPacked || quickActiveFilter?.settings?.isPacked;
        this.obligateTimeWindow = $stateParams.obligateTimeWindow || quickActiveFilter?.settings?.obligateTimeWindow;
        this.schedulingRequired = $stateParams.schedulingRequired || quickActiveFilter?.settings?.schedulingRequired;
        this.fulfillmentDisplayStatus = commonsService.parseArrayStateParam($stateParams.fulfillmentDisplayStatus) || quickActiveFilter?.settings?.fulfillmentDisplayStatus || [];
        this.noFromLocation = !!$stateParams.noFromLocation ? JSON.parse($stateParams.noFromLocation) : quickActiveFilter?.settings?.noFromLocation;
        this.noToLocation = !!$stateParams.noToLocation ? JSON.parse($stateParams.noToLocation) : quickActiveFilter?.settings?.noToLocation;
        this.pickupDepotIds = commonsService.parseArrayStateParam($stateParams.pickupDepotIds) || quickActiveFilter?.settings?.pickupDepotIds || [];
        this.destinationDepotIds = commonsService.parseArrayStateParam($stateParams.destinationDepotIds) || quickActiveFilter?.settings?.destinationDepotIds || [];
        this.programTypes = commonsService.parseArrayStateParam($stateParams.programTypes) || quickActiveFilter?.settings?.programTypes || [];
        this.addressQualities = commonsService.parseArrayStateParam($stateParams.addressQualities) || quickActiveFilter?.settings?.addressQualities || [];
        this.configuredFieldName = !!$stateParams.configuredFieldName ? $stateParams.configuredFieldName : quickActiveFilter?.settings.configuredFieldName;
        this.configuredFieldValue = !!$stateParams.configuredFieldValue ? $stateParams.configuredFieldValue : quickActiveFilter?.settings.configuredFieldValue;
        this.schedulingSmsStatuses = commonsService.parseArrayStateParam($stateParams.schedulingSmsStatuses) || quickActiveFilter?.settings?.schedulingSmsStatuses || [];

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Orders"});
      },
      resolve: {
        metadataSettings: function (settingsService: SettingsService, site) {
          return settingsService.getSiteMetadata();
        }
      }
    })

    // .state('order', {
    //   parent: 'bringoz.site',
    //   url: '/order/:id',
    //   abstract: true,
    //   template: '<oms-order-view order="order"></oms-order-view>',
    //   controller: function (order, $omsOrder, $scope, triBreadcrumbsService) {
    //     $scope.order = order;
    //     $omsOrder(order.id).$bind($scope, 'order');
    //
    //     // Bread Crumbs
    //     triBreadcrumbsService.reset();
    //     triBreadcrumbsService.addCrumb({name: order.id});
    //     triBreadcrumbsService.addCrumb({name: 'Orders', state: 'orders.table'});
    //   },
    //   resolve: {
    //     order: function ($omsOrder, $q, $stateParams, site) {
    //       return $omsOrder($stateParams.id).$instantGet();
    //     }
    //   }
    // })
    .state('order', {
      parent: 'bringoz.site',
      url: '/order/:id',
      abstract: true,
      template: '<ui-view class="full-height"></ui-view>',
      controller: function (order, $omsOrder, $scope, site) {
        $scope.order = order;
        // $omsOrder(order.id).$bind($scope, 'order');
      },
      resolve: {
        order: function ($omsOrder, $q, $stateParams, site) {
          return $omsOrder($stateParams.id).$instantGet();
        },
        metadataSettings: function (settingsService: SettingsService, site) {
          return settingsService.getSiteMetadata();
        }
      }
    })
    .state('order.info', {
      url: '',
      params: {
        doDispatch: null,
        autoDispatch: null
      },
      template: '<oms-order-view order="order" do-dispatch="vm.doDispatch" auto-dispatch="vm.autoDispatch"></oms-order-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, $stateParams) {

        this.doDispatch = $stateParams.doDispatch;
        this.autoDispatch = $stateParams.autoDispatch;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: $stateParams.id, ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: 'Orders', state: 'orders.table'});
      }
    })

    .state('order.edit', {
      url: '/edit',
      template: '<oms-order-edit-view order="vm.order"></oms-order-edit-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, order) {

        this.order = angular.copy(order);

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Edit'});
        triBreadcrumbsService.addCrumb({
          name: order.id,
          state: 'order.info',
          params: {id: order.id},
          ignoreTranslate: true
        });
        triBreadcrumbsService.addCrumb({name: 'Orders', state: 'orders.table'});
      }
    })

    .state('order.duplicate', {
      url: '/duplicate',
      template: '<oms-order-create-view order="vm.order"></oms-order-create-view>',
      controllerAs: 'vm',
      controller: function (triBreadcrumbsService, order) {

        this.order = angular.copy(order);

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: 'Duplicate'});
        triBreadcrumbsService.addCrumb({name: 'Orders', state: 'orders.table'});
      }
    })

    //*** Creates View **//
    .state('order-create', {
      parent: 'bringoz.site',
      url: '/order-create',
      controllerAs: 'vm',
      params: {
        order: null,
        isPrefilled: false
      },
      template: '<oms-order-create-view order="vm.order" is-prefilled="vm.isPrefilled"></oms-order-create-view>',
      controller: function (triBreadcrumbsService, site, $stateParams, metadataSettings) {
        this.order = $stateParams.order;
        this.isPrefilled = $stateParams.isPrefilled;

        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Create Order"});
        triBreadcrumbsService.addCrumb({name: 'Orders', state: 'orders.table'});
      },
      resolve: {
        metadataSettings: function (settingsService: SettingsService, site) {
          return settingsService.getSiteMetadata();
        }
      }
    })

    //*** Upload Orders View **//
    .state('orders-upload', {
      parent: 'bringoz.site',
      url: '/orders-upload',
      controllerAs: 'vm',
      template: '<oms-import-view schema-default-fields="vm.schemaDefaultFields" schemas="vm.schemas"></oms-import-view>',
      controller: function (triBreadcrumbsService, schemaDefaultFields, schemas, site) {

        this.schemaDefaultFields = schemaDefaultFields;
        this.schemas = schemas || [];
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Upload Orders"});
        triBreadcrumbsService.addCrumb({name: 'Orders', state: 'orders.table'});
      },
      resolve: {
        schemaDefaultFields: (site, batchRequestsService: BatchRequestsService) => {
          return batchRequestsService.getSchemaDefaultFields("OmsOrder");
        },
        schemas: (site, batchRequestsService: BatchRequestsService) => {
          return batchRequestsService.getSchemas("OmsOrder");
        }
      }
    })


  //*** Old Order View (Using Shipments) **//
  // //*** Delivery View **//
  // .state('order.delivery', {
  //   url: '/delivery/:deliveryId',
  //   abstract: true,
  //   views: {
  //     'mainView@order': {
  //       template: '<oms-delivery-details delivery-id="vm.deliveryId" current-nav-item="vm.currentNavItem"></oms-delivery-details>',
  //       controllerAs: 'vm',
  //       controller: function ($stateParams) {
  //         this.currentNavItem = '/info';
  //         this.deliveryId = $stateParams.deliveryId;
  //       }
  //     }
  //   }
  // })
  // .state('order.delivery.info', {
  //   url: '/info',
  //   controllerAs: 'vm',
  //   template: '<delivery-details-info delivery="$ctrl.delivery" status="$ctrl.delivery.status"></delivery-details-info>',
  //   controller: function (triBreadcrumbsService, $stateParams) {
  //
  //     // Bread Crumbs
  //     triBreadcrumbsService.reset();
  //     triBreadcrumbsService.addCrumb({name: 'Info'});
  //     triBreadcrumbsService.addCrumb({name: $stateParams.deliveryId});
  //     triBreadcrumbsService.addCrumb({name: 'Delivery'});
  //     triBreadcrumbsService.addCrumb({
  //       name: $stateParams.id,
  //       state: 'order.info',
  //       params: {id: $stateParams.id}
  //     });
  //     triBreadcrumbsService.addCrumb({name: 'Orders', state: 'orders.table'});
  //   }
  // })
  // .state('order.delivery.pricing', {
  //   url: '/pricing',
  //   template: '<delivery-detailed-view-pricing delivery="$ctrl.delivery"></delivery-detailed-view-pricing>',
  //   controller: function (triBreadcrumbsService, $stateParams) {
  //
  //     // Bread Crumbs
  //     triBreadcrumbsService.reset();
  //     triBreadcrumbsService.addCrumb({name: 'Pricing'});
  //     triBreadcrumbsService.addCrumb({name: $stateParams.deliveryId});
  //     triBreadcrumbsService.addCrumb({name: 'Delivery'});
  //     triBreadcrumbsService.addCrumb({name: $stateParams.id});
  //     triBreadcrumbsService.addCrumb({name: 'Orders', state: 'orders.table'});
  //   }
  // })
  // .state('order.delivery.auctions', {
  //   url: '/auctions',
  //   template: '<auctions-list-view delivery="$ctrl.delivery"></auctions-list-view>',
  //   controller: function (triBreadcrumbsService, $stateParams) {
  //
  //     // Bread Crumbs
  //     triBreadcrumbsService.reset();
  //     triBreadcrumbsService.addCrumb({name: 'Auctions'});
  //     triBreadcrumbsService.addCrumb({name: $stateParams.deliveryId});
  //     triBreadcrumbsService.addCrumb({name: 'Delivery'});
  //     triBreadcrumbsService.addCrumb({name: $stateParams.id});
  //     triBreadcrumbsService.addCrumb({name: 'Orders', state: 'orders.table'});
  //   }
  // })
  // .state('order.delivery.timeline', {
  //   url: '/timeline',
  //   template: '<delivery-history-view delivery="$ctrl.delivery"></delivery-history-view>',
  //   controller: function (triBreadcrumbsService, $stateParams) {
  //
  //     // Bread Crumbs
  //     triBreadcrumbsService.reset();
  //     triBreadcrumbsService.addCrumb({name: 'Timeline'});
  //     triBreadcrumbsService.addCrumb({name: $stateParams.deliveryId});
  //     triBreadcrumbsService.addCrumb({name: 'Delivery'});
  //     triBreadcrumbsService.addCrumb({name: $stateParams.id});
  //     triBreadcrumbsService.addCrumb({name: 'Orders', state: 'orders.table'});
  //   }
  // })

}
